import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-solid",
  "use": "star-solid-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"star-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M27.6 24.5l12.4-9H24.7L20 1l-4.7 14.5H0l12.4 9L7.6 39 20 30l12.4 9-4.8-14.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol